export function fetchEnquiries() {
    return;
}

export function deleteEnquiry(id) {
    return;
}